<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col :md="6" :sm="24">
            <a-form-item
              :label="$t(I18N_KEY.REPAYREPORT + 'requestDate')"
              :labelCol="{ span: 6 }"
              :wrapperCol="{ span: 14, offset: 1 }"
            >
              <a-range-picker v-model="queryParam.queryDate" format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24">
            <a-form-item :label="$t(I18N_KEY.REPAYREPORT + 'appSsid')">
              <a-select mode='multiple'
                        v-model='queryParam.mainSids'
                        style="width: 80%"
              >
                <a-select-option v-for='item in mainAppList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="7" :sm="24">
            <a-form-item label="币种" style="margin-bottom: 0;">
              <a-radio-group v-model="currencyCode" @change="onCurrencyChange" button-style="solid">
                <a-radio-button value="LOCAL">本币</a-radio-button>
                <a-radio-button value="CNY">人民币 ({{ cnyRate }})</a-radio-button>
                <a-radio-button value="USD">美金 ({{ usdRate }})</a-radio-button>
              </a-radio-group>
            </a-form-item>
          </a-col>
          <a-col :md="18" :sm="24">
            <span style="float: left; overflow: hidden" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery('')" icon="search" style="margin-left: 8px">{{
                $t('search')
              }}</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">{{
                $t('reset')
              }}</a-button>
              <a-button type='primary' @click="downLoadData('')" icon='download'
                        style='margin-left: 8px'>{{ $t('exportFile')
                }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="false"
        :loading="loading"
        bordered
        @change="handleTableChange"
      >
        <Dict slot="approvalStatus" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS">{{ text }}</Dict>
      </a-table>
    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import { getApplistExcludingSubApp } from '@/webpublicapi/order'
import { getLoanRepaymentInfo } from '@/webpublicapi/repaymentReport'
import { exportFileByPost } from '@/api/exportFile'
import Dict from '../modules/Dict'
import DictSelect from '../modules/DictSelect'
import moment from 'moment'
import {getExchangeRate} from "@/webpublicapi/statistics";
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.',
  REPAYREPORT: 'repayReport.',
}
export default {
  name: 'repayReport',
  components: {
    Dict,
    DictSelect,
  },
  data() {
    return {
      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      exportParams: '',
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10,
      },
      total: 0,
      dataSource: [],
      mainAppList: [],
      // 查询条件
      queryParam: {
        mainSids: [],
        queryDate: [moment().add('days', -7), moment()],
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc',
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 },
      },
      currencyCode: 'LOCAL', // 当前货币代码：LOCAL-本币，CNY-人民币，USD-美金
      exchangeRate: 1, // 当前使用的汇率
      cnyRate: 1, // 人民币汇率（缓存）
      usdRate: 1, // 美金汇率（缓存）
    }
  },
  computed: {
    columns() {
      return [
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'curDate'),
          align: 'left',
          dataIndex: 'curDate',
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'loanAmount'),
          align: 'left',
          dataIndex: 'loanAmount',
          customRender: this.convertAmount,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'repaymentAmount'),
          align: 'left',
          dataIndex: 'repaymentAmount',
          customRender: this.convertAmount,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'grossProfit'),
          align: 'left',
          dataIndex: 'grossProfit',
          customRender: this.convertAmount,
        },
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'grossProfitRate'),
          align: 'left',
          dataIndex: 'profitRate',
          customRender: (text, record) => {
            // 根据贷款金额和毛利润计算利率
            if (record.loanAmount === 0 || record.grossProfit === 0) {
              return 0 + '%'
            } else if (record.loanAmount === 0) {
              return '-'
            } else {
              return (record.grossProfit * 100 / record.loanAmount ).toFixed(2) + '%'
            }
          }
        }
      ]
    },
  },
  created() {
    this.initAllRates()
    getApplistExcludingSubApp().then(res => {
      this.mainAppList = []
      this.mainInAppList = res.data || []
      for (var i = 0; i < this.mainInAppList.length; i++) {
        if (this.mainInAppList[i].appssid != '') {
          this.mainAppList.push(this.mainInAppList[i])
        }
      }
    });
    getApplist().then(res => {
      this.appList = res.data || []
    })
    // this.loadData(1);
  },
  methods: {
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    searchQuery(arg) {
      this.loadData(1, arg)
    },
    //计算利率的方法
    calculateRate(a, b) {
      if (a === 0 || b === 0) {
        return 0 + '%'
      } else if (b === 0) {
        return '-'
      } else {
        return (a / b * 100).toFixed(2) + '%'
      }
    },
    loadData(arg, arg2) {
      // 加载数据 若传入参数1则加载第一页的内容
      console.log(arg2)
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams(arg2) // 查询条件
      getLoanRepaymentInfo(Object.assign({}, params))
        .then((res) => {
          if (res.code === 1000) {
            this.dataSource = res.data || [];
          } else {
            this.total = 0;
            this.dataSource = [];
            this.$message.error(res.msg);
          }
          this.loading = false;
        })
        .catch((e) => {
          this.loading = false;
          this.$message.error(e.message);
        })
    },
    async downLoadData() {
      var params = this.getQueryParams()// 查询条件
      var fileName = 'loanRepaymentInfo';
      if (params.startDate !== null && params.startDate !== '' && params.startDate !== 'undefined') {
        fileName = fileName + "_" + params.startDate + '.xlsx';
      }
      if (params.endDate !== null && params.endDate !== '' && params.endDate !== 'undefined') {
        fileName = fileName + "_" + params.endDate + '.xlsx';
      }
      this.loading = true
      try {
        const result = await exportFileByPost(
          `/api/web/webpublic/payChecking/exportLoanRepaymentInfo`,
          params,
          fileName
        );
        if (result instanceof Error) {
          this.$message.error(result.message);
        }
      } catch(error) {
          this.$message.error(error.message);
      } finally{
        this.loading = false
      }
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams(arg) {
      const { queryDate } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: (queryDate && queryDate.length) ? this.transformTime(queryDate[0]) : undefined,
        endDate: (queryDate && queryDate.length) ? this.transformTime(queryDate[1]) : undefined
      }
      delete data.queryDate
      return filterObj(data)
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this;
      that.queryParam.queryDate = [moment().add('days', -7), moment()];
      that.queryParam.mainSids = [];
      // that.loadData(this.form.pageNum)
    },

    // 初始化所有汇率（页面加载时执行）
    initAllRates () {
      const currency = process.env.VUE_APP_CURRENCY
      console.log('currency--->', currency)
      if(!currency)
        return

      getExchangeRate({currency: currency}).then((res)=>{
        if(res.code===1000){

          this.data = res.data || [];

          this.cnyRate = this.data['CNY'] || 1
          this.usdRate = this.data['USD'] || 1
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false;
        this.$message.error(e.message);
      })
    },

    // 货币切换处理
    onCurrencyChange (e) {
      const selectedCurrency = e.target.value

      switch (selectedCurrency) {
        case 'LOCAL':
          this.exchangeRate = 1
          this.$message.info('已切换为本币')
          break
        case 'CNY':
          if (this.cnyRate !== null && this.cnyRate !== undefined) {
            this.exchangeRate = this.cnyRate
            this.$message.success(`已切换到人民币，汇率：${this.cnyRate}`)
          } else {
            this.$message.warning('人民币汇率未加载')
          }
          break
        case 'USD':
          if (this.usdRate !== null && this.usdRate !== undefined) {
            this.exchangeRate = this.usdRate
            this.$message.success(`已切换到人民币，汇率：${this.usdRate}`)
          } else {
            this.$message.warning('美金汇率未加载')
          }
          break
      }
    },

    // 汇率转换格式化方法（使用公共工具）
    convertAmount (text) {
      return this.$convertCurrency(text, this.exchangeRate)
    },
  },
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/common.less';
</style>
